import { useState } from 'react';
import { IconButton, ListItemText, Menu, MenuItem } from '@mui/material';
import MoreHoriz from '@mui/icons-material/MoreHoriz';
import { useTranslation } from 'react-i18next';

type ReporterNoteActionMenuProps = {
  isArchived: boolean;
  onToggleArchived: () => void;
  disabled?: boolean;
};

export const ReporterNoteActionMenu = (
  props: ReporterNoteActionMenuProps,
): JSX.Element => {
  const { isArchived, onToggleArchived, disabled } = props;
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const closeMenu = (): void => setAnchorEl(null);

  const handleToggleArchived = (): void => {
    onToggleArchived();
    closeMenu();
  };

  return (
    <>
      <IconButton
        size="small"
        aria-label={t('reporterNotes.actions.menu')}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        disabled={disabled}
      >
        <MoreHoriz />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ list: { sx: { padding: 0, minWidth: 175 } } }}
      >
        <MenuItem onClick={handleToggleArchived}>
          <ListItemText
            primary={
              isArchived
                ? t('reporterNotes.actions.undelete')
                : t('reporterNotes.actions.delete')
            }
          />
        </MenuItem>
      </Menu>
    </>
  );
};
